import type { PlantEdge } from '../types'
import { coercePlantProvenance, normalizePlantConfidence } from './provenance'

function asRecord(value: unknown): Record<string, unknown> {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) return {}
  return value as Record<string, unknown>
}

/**
 * Cypher edge collections may include a sentinel row with null endpoints
 * when an optional match returns nothing. Filter those out.
 */
export function extractPlantEdges(value: unknown): PlantEdge[] {
  if (!Array.isArray(value)) return []
  const edges: PlantEdge[] = []
  for (const item of value) {
    if (!item || typeof item !== 'object') continue
    const obj = item as Record<string, unknown>
    if (typeof obj['source'] !== 'string' || typeof obj['target'] !== 'string') continue
    const rawProps = asRecord(obj['props'])
    const provenance = coercePlantProvenance(rawProps['provenance'])
    const confidence = normalizePlantConfidence(rawProps)
    const props = { ...rawProps }
    delete props['provenance']
    delete props['confidence']
    delete props['source_kind']
    delete props['source_file']

    const edge: PlantEdge = {
      type: typeof obj['type'] === 'string' ? obj['type'] : '',
      source: obj['source'],
      target: obj['target'],
      props
    }
    if (provenance) edge.provenance = provenance
    if (confidence !== undefined) edge.confidence = confidence
    edges.push(edge)
  }
  return edges
}
